import type { SVGProps } from 'react';

export function BurgerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.2 16.8c-.33 0-.6.27-.6.6a3 3 0 0 0 3 3h10.8a3 3 0 0 0 3-3c0-.33-.27-.6-.6-.6zm-.6-6.825c0 .458.371.825.825.825h15.15a.825.825 0 0 0 .825-.825c0-.645-.098-1.29-.405-1.856C19.163 6.589 16.909 3.6 12 3.6S4.838 6.585 4.005 8.12C3.698 8.685 3.6 9.33 3.6 9.975M2.4 13.8c0 .664.536 1.2 1.2 1.2h16.8c.664 0 1.2-.536 1.2-1.2s-.536-1.2-1.2-1.2H3.6c-.664 0-1.2.536-1.2 1.2M12 5.1c.499 0 .9.401.9.9s-.401.9-.9.9a.9.9 0 0 1-.9-.9c0-.499.401-.9.9-.9M6.9 7.2c0-.499.401-.9.9-.9s.9.401.9.9-.401.9-.9.9a.9.9 0 0 1-.9-.9m9.3-.9c.499 0 .9.401.9.9s-.401.9-.9.9a.9.9 0 0 1-.9-.9c0-.499.401-.9.9-.9" />
    </svg>
  );
}
